<proffeo-ui-dialog [title]="'company-groups.modals.select-users-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    @if (companyUsers()?.length) {
      <proffeo-select-users-list
        [(selectedUsers)]="selectedUsers"
        [lockedUserIds]="[lockedUser()]"
        [originalUsers]="companyUsers()"
      ></proffeo-select-users-list>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <button matDialogClose>
      {{ 'close' | translate }}
    </button>
    <button
      (click)="save()"
      class="button-accent"
    >
      {{ 'save-and-close' | translate }}
    </button>
  </div>
</proffeo-ui-dialog>
